import { createLightboxPreviewItem } from '@/components/media/ImageLightboxPreviewTrigger'

export function getMessageInspirationPreviewEntries(media) {
  const inspirationMedia = Array.isArray(media) ? media : []

  return inspirationMedia.reduce((entries, item, index) => {
    const alt = `Inspiration photo ${index + 1}`
    const caption = item.name || alt
    const previewItem = createLightboxPreviewItem({
      media: item,
      id: item.id ?? index,
      alt,
      caption,
    })

    if (!previewItem) {
      return entries
    }

    entries.push({
      media: item,
      mediaIndex: index,
      alt,
      caption,
      previewItem,
    })

    return entries
  }, [])
}
